var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6022_2908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7673 26.6186C51.7673 41.3196 40.1788 53.2372 25.8836 53.2372C11.5885 53.2372 0 41.3196 0 26.6186C0 11.9176 11.5885 0 25.8836 0C40.1788 0 51.7673 11.9176 51.7673 26.6186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5186 0C10.3314 1.23325 3.05176e-05 12.6799 3.05176e-05 26.6186C3.05176e-05 40.5573 10.3314 52.0039 23.5186 53.2372V0ZM28.4158 0.0154493V53.2217C41.5231 51.9078 51.7673 40.4983 51.7673 26.6186C51.7673 12.7388 41.5231 1.32934 28.4158 0.0154493Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3872 26.6187C47.3872 38.8824 37.7596 48.8241 25.8834 48.8241C14.0071 48.8241 4.37952 38.8824 4.37952 26.6187C4.37952 14.355 14.0071 4.41336 25.8834 4.41336C37.7596 4.41336 47.3872 14.355 47.3872 26.6187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1402 26.8542C43.1402 36.5009 35.567 44.3212 26.225 44.3212C16.883 44.3212 9.30981 36.5009 9.30981 26.8542C9.30981 17.2075 16.883 9.38724 26.225 9.38724C35.567 9.38724 43.1402 17.2075 43.1402 26.8542Z",
    fill: "#0038A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8989 20.2749V24.1011H24.3374V37.0473H20.874V40.786H31.6982V37.0473H28.4791V24.1011V20.2749H20.8989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7303 15.7156C28.7303 17.1945 27.5693 18.3934 26.1371 18.3934C24.7049 18.3934 23.5438 17.1945 23.5438 15.7156C23.5438 14.2367 24.7049 13.0378 26.1371 13.0378C27.5693 13.0378 28.7303 14.2367 28.7303 15.7156Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6022_2908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 53,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditInformation);
export default __webpack_public_path__ + "static/media/CreditInformation.884fd52c40b856c297b924505bf2e6ef.svg";
export { ForwardRef as ReactComponent };